__turbopack_context__.v({
  "challengeCard": "ProvenChannel-module__2uzrAW__challengeCard",
  "challengeCardText": "ProvenChannel-module__2uzrAW__challengeCardText",
  "darkSection": "ProvenChannel-module__2uzrAW__darkSection",
  "sectionBorder": "ProvenChannel-module__2uzrAW__sectionBorder",
  "sectionSubTitle": "ProvenChannel-module__2uzrAW__sectionSubTitle",
  "sectionTitle": "ProvenChannel-module__2uzrAW__sectionTitle",
  "sectionTitleWrap": "ProvenChannel-module__2uzrAW__sectionTitleWrap",
  "sectionWrapper": "ProvenChannel-module__2uzrAW__sectionWrapper",
});
